import { Grid2, Link, Stack, Typography } from '@mui/material';
import TextLogo from 'components/TextLogo';
import VectorLogo from 'components/VectorLogo';
import { Trans, useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import AppleAppStore from 'assets/apple-app-store.svg?react';
import GooglePlayStore from 'assets/google-play-store.svg?react';
import {
  AppStoreLinks,
  MEMBERSHIP_PLANS,
  MEMBERSHIP_PLANS_AMOUNTS,
} from '../../../../constants';
import { FeaturesList } from '../SupportUsContent/FeatureList';

const useStyles = makeStyles()((theme) => ({
  textLogo: {
    width: 246,
    fill: theme.palette.text.primary,
  },
}));

export const EmbeddedSupportUs = (): JSX.Element => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Grid2 container sx={{ py: 1 }} spacing={4}>
      <Grid2 size={12}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="center"
          spacing={1}
        >
          <VectorLogo size={48} sx={{ pb: 0.5 }} />

          <TextLogo className={classes.textLogo} />
        </Stack>

        <Typography sx={{ lineHeight: '22px', pt: 1 }}>
          {t('supportUs.embedded.description')}
        </Typography>
      </Grid2>

      <Grid2 size={12}>
        <Typography variant="h3" align="center" fontWeight="fontWeightBold">
          {t('supportUs.embedded.memberSupport')}
        </Typography>

        <Typography sx={{ lineHeight: '22px', pt: 1 }}>
          {t('supportUs.embedded.freeSupport')}
        </Typography>
      </Grid2>

      <Grid2 size={{ xs: 12, sm: 6 }}>
        <Stack spacing={2}>
          <Typography variant="h2" sx={{ fontSize: 24 }}>
            {t('supportUs.membership.title')}
          </Typography>

          <Stack direction="row">
            <Typography sx={{ fontSize: 16 }}>
              <Trans
                i18nKey="supportUs.membership.price"
                values={{
                  price: MEMBERSHIP_PLANS_AMOUNTS[MEMBERSHIP_PLANS.yearly],
                }}
              >
                <Typography
                  variant="h3"
                  component="span"
                  sx={{
                    fontWeight: 500,
                    fontSize: 20,
                    verticalAlign: 'top',
                  }}
                >
                  $
                </Typography>
                <Typography variant="h1" component="span" sx={{ fontSize: 36 }}>
                  24.99
                </Typography>
                per year
              </Trans>
            </Typography>
          </Stack>

          <FeaturesList />
        </Stack>
      </Grid2>

      <Grid2 size={{ xs: 12, sm: 6 }}>
        <Stack spacing={2}>
          <Typography variant="h2" sx={{ fontSize: 24 }}>
            {t('supportUs.proMembership.title')}
          </Typography>

          <Stack direction="row">
            <Typography sx={{ fontSize: 16 }}>
              <Trans
                i18nKey="supportUs.membership.price"
                values={{
                  price: MEMBERSHIP_PLANS_AMOUNTS[MEMBERSHIP_PLANS.proYearly],
                }}
              >
                <Typography
                  variant="h3"
                  component="span"
                  sx={{
                    fontWeight: 500,
                    fontSize: 20,
                    verticalAlign: 'top',
                  }}
                >
                  $
                </Typography>
                <Typography variant="h1" component="span" sx={{ fontSize: 36 }}>
                  99.99
                </Typography>
                per year
              </Trans>
            </Typography>
          </Stack>

          <FeaturesList plan="pro_yearly" />
        </Stack>
      </Grid2>

      <Grid2 size={12}>
        <Stack
          sx={{
            width: '100%',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: { xs: 'column', sm: 'row' },
            gap: 2,
          }}
        >
          <Link
            href={AppStoreLinks.ios}
            target="_blank"
            sx={{ pointerEvents: 'auto', height: '54px' }}
          >
            <AppleAppStore width="180px" height="54px" />
          </Link>
          <Link
            href={AppStoreLinks.android}
            target="_blank"
            sx={{ pointerEvents: 'auto', height: '54px' }}
          >
            <GooglePlayStore width="180px" height="54px" />
          </Link>
        </Stack>
      </Grid2>
    </Grid2>
  );
};
